/**
 * Public auth flows (unauthenticated): always use light theme.
 * Keep in sync with the blocking script in `index.html`.
 */
export const AUTH_PUBLIC_PATH_PREFIXES = [
  "/login",
  "/register",
  "/auth/verify",
  "/auth/sso/callback",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/accept-invitation",
] as const;

export function isPublicAuthPath(pathname: string): boolean {
  return AUTH_PUBLIC_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
